import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Save (floppy) — interior write-window LED blinks on a 1.6s rhythm,
 *  hinting at write activity. Outer chassis static. */
export function IcnSave(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="save">
      {/* Chassis */}
      <path d="M3 2h8l2 2v10H3V2z" />
      {/* Label slot */}
      <rect x="5" y="9" width="6" height="4" rx="0.5" />
      {/* Write indicator LED */}
      <circle cx="11" cy="4" r="0.7" fill="currentColor" stroke="none">
        {animate && (
          <animate
            attributeName="opacity"
            values="1;0.25;1"
            keyTimes="0;0.5;1"
            dur="1.6s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      {/* Shutter detail */}
      <line x1="6" y1="2" x2="6" y2="5" />
      <line x1="10" y1="2" x2="10" y2="5" />
    </Svg>
  );
}
